import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../contexts/AuthCtx";
import { useAutoScrollOnLoad } from "../../hooks/autoScrollOnLoad";
import ContactListSection from "../../sections/ContactList";
import { Helmet } from "react-helmet";
import AuthService from "../../api/auth";

export default function AboutPage() {

    const authCtx = useAuth();
    const emailRef = useRef(null);

    const [loading, setLoading] = useState(0);  // initial = 0, loading = 1, success = 2, error = 3

    const handleSubmitForm = (e) => {
        //   // setLoading(1);
        e.preventDefault();
        // window.alert("Submitted token :: ", token);
        //   setRefreshReCaptcha(!refreshReCaptcha);
        setLoading(1);
        AuthService.joinNewsletter({
          name: '',
          email: emailRef.current.value
        }, {}).then((r) => {
          if(r && r.status === 200) {
            setLoading(2);
          }
          else
          {
            setLoading(3);
          }
        })
      }

      useEffect(() => {
        if(loading === 2) {
            setTimeout(() => {
                emailRef.current.value = '';
                setLoading(0);
            }, 3000);
        }
        else if(loading === 3) {
          setTimeout(() => {
            setLoading(0);
          }, 3000);
        }
      }, [loading])


    useEffect(() => {
        authCtx.set_nav_mode('normal');
    }, []);

    useAutoScrollOnLoad();

    return (
        <>
            <Helmet>
                <title>About - Equibre</title>
                <meta name="description" content="We working towards making life easy and satisfiable so you can focus on your business." />
            </Helmet>
            <section className="page-header-section">
                <div className="inner">
                    <h1>About</h1>
                    <p>We working towards making life easy and satisfiable so you can focus on your business.</p>
                </div>
            </section>
            {/* <section className="about-page-section">
                <div className="inner">
                    <div className="content">
                        <div className="page-content">
                            <h1 className="page-content-hdr">
                                Our mission is to make your life easy with satisfaction so you can
                                focus on your bussiness. We strive to achieve this by focusing on
                                three core principles.
                            </h1>
                        </div>
                        <div className="page-content">
                            <a href="#">Learn more</a>
                        </div>
                        <div className="page-image">
                            <img src="https://f.start.me/us.gov" />
                        </div>
                    </div>
                </div>
            </section> */}
            {/* <section className="about-page-section">
                <div className="inner">
                    <div className="content">
                        <div className="page-content">
                            <h1 className="page-content-hdr">Our services</h1>
                        </div>
                        <div className="page-image">
                            <img src="https://f.start.me/us.gov" />
                        </div>
                    </div>
                </div>
            </section> */}

            <section className="about-section">
                <div className="inner">
                    <div className="card-col">
                        <div className="card-row">
                            <div className="inner">
                                <div className="card-hdr">
                                    <div className="col">
                                        <h1>Our mission is to make your life easy with satisfaction so you can
                                            focus on your bussiness. We strive to achieve this by focusing on
                                            three core principles.</h1>
                                    </div>
                                </div>
                                <div className="card-label">
                                    <p>OUR MISSION</p>
                                </div>
                            </div>
                        </div>
                        <div className="card-row">
                            <div className="inner">
                                <div className="card-hdr">
                                    <div className="col">
                                        <h1>Through innovative and easy-to-access services, we want to enrich every individuals, social-communities, businesses across the world.</h1>
                                    </div>
                                    <div className="col">
                                        <h1>We strive to empower the business which are just starting up.</h1>
                                    </div>
                                </div>
                                <div className="card-label">
                                    <p>OUR VISION</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-col">
                        <div className="card-row">
                            <div className="inner">
                                <div className="card-hdr">
                                    <div className="col">
                                        <h1>Quality - </h1><h3>We ensure that every product and service we offer meets the highest standards of quality.</h3>
                                    </div>
                                    <div className="col">
                                        <h1>Innovation - </h1><h3>We are constantly exploring new technologies and ideas to bring the best solutions to our customers.</h3>
                                    </div>
                                    <div className="col">
                                        <h1>Customer service - </h1><h3>Our customers are at the heart of everything we do. We aim to exceed their expectations in every interaction</h3>
                                    </div>
                                </div>
                                <div className="card-label">
                                    <p>CORE PRINCIPLES</p>
                                </div>
                            </div>
                        </div>
                        <div className="card-row">
                            <div className="inner">
                                <div className="card-hdr">
                                    <div className="col">
                                        <h1>Expertise - </h1><h3>With years of experience in the industry, we have the knowledge and expertise to provide top-notch products and services.</h3>
                                    </div>
                                    <div className="col">
                                        <h1>Reliability - </h1><h3>You can count on us to deliver consistent, reliable products and services.</h3>
                                    </div>
                                    <div className="col">
                                        <h1>Customer-Centric Approach - </h1><h3>We listen to our customers and tailor our solutions to meet their specific needs.</h3>
                                    </div>
                                </div>
                                <div className="card-label">
                                    <p>WHY US?</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <ContactListSection /> */}

            <section className="page-header-section">
                <div className="inner">
                    <h1>Contact</h1>
                    <p>Connect us through any channel and we will respond as soon as possible.</p>
                </div>
            </section>
            <section className="work-section contact-list-section no-border">
                <div className="inner">
                    <div className="services-container" style={{ flexWrap: 'nowrap' }}>
                        <div className="service-card small -st">
                            <div className="inner">
                                <div className="label">
                                    <a href="#" className="text-button">Live chat</a>
                                    <p>You can chat with us live on working hours.</p>
                                </div>
                            </div>
                        </div>
                        <div className="service-card small">
                            <div className="inner">
                                <div className="label">
                                    <a href="#" onClick={(e) => {
                                        e.preventDefault();
                                        authCtx.toggleShowStartProjectDialog(true);
                                    }} className="text-button">Request a callback</a>
                                    <p>Write us in the contact form and we will be in touch with you.</p>
                                </div>
                            </div>
                        </div>
                        <div className="service-card small">
                            <div className="inner">
                                <div className="label">
                                    <a href="mailto:contact@equibre.com" className="text-button">Send us email</a>
                                    <p>We always responds as fast as we can.</p>
                                </div>
                            </div>
                        </div>
                        <div className="service-card small">
                            <div className="inner">
                                <div className="label">
                                    <a href="https://blog.equibre.com" target="_blank" className="text-button">Visit our blogs</a>
                                    <p>Many peoples found our blogs helpful.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col ns-form">
                        <div>
                            <h1>Join our newsletter</h1>
                        </div>
                        <form className="newsletter-form" onSubmit={handleSubmitForm}>
                            <div>
                                <input ref={emailRef} required placeholder="Your email*" type="email" />
                            </div>
                            <div>
                                <button disabled={loading !== 0} type="submit">{loading === 1 ? "Joining..." : loading === 2 ? "Joined, Thank you!" : loading === 3 ? "Failed to submit." : "Join"}</button>
                            </div>
                        </form>
                    </div>
                    <div className="col regr-off ns-form">
                        <div>
                            <h1>Registered office</h1>
                        </div>
                        <div><p>Unit 101 Oxford towers, 139 Hal Old Airport RD, Hulsur Bazaar, Bangalore- 560008, Karnataka, India</p></div>
                    </div>
                </div>
            </section>
        </>
    );
}